import { render, staticRenderFns } from "./ThirdPartiesTable.vue?vue&type=template&id=f8d603f4&"
import script from "./ThirdPartiesTable.vue?vue&type=script&lang=js&"
export * from "./ThirdPartiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports